/** @file Field check for an object used as a map: names match a pattern, values pass a check. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';

/** Check for a map whose keys match `keyPattern` (default `NAME_PATTERN`) and whose values pass `item`. */
export function checkRecord(item: FieldCheck, keyPattern: RegExp = NAME_PATTERN): FieldCheck {
  return (value, path) => {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) failField(path, 'object', value);
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      if (!keyPattern.test(key)) failField(`${path}/${key}`, `key matching ${String(keyPattern)}`, key);
      item(v, `${path}/${key}`);
    }
  };
}
